import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, CircularProgress, Typography, withStyles, Button, TextField } from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import UserStore from '../../store/UserStore';
import presenselogo from '../../images/Presense/Logo/presense-logo-with-BG-negative.png';
import presenseAlternatelogo from '../../images/Presense/Logo/presense-alternate-logo.png';
import Swal from 'sweetalert2';

class ResetPasswordPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            newPassword: '',
            confirmPassword: '',
            errorMessage: '',
            loading: false,
        };
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        const { newPassword, confirmPassword } = this.state;
        const { match } = this.props;
        const token = match.params.token;

        if (newPassword !== confirmPassword) {
            this.setState({ errorMessage: 'รหัสผ่านไม่ตรงกัน!' });
            return;
        }

        this.setState({ loading: true });

        try {
            await UserStore.resetPasswordByToken({ password: newPassword, token });
            this.setState({ loading: false, errorMessage: '' });
            Swal.fire({
                title: 'เปลี่ยนรหัสผ่านสำเร็จ',
                // message: 'ดำเนินการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน',
                type: 'success',
                customClass: {
                    container: 'my-swal',
                },
            }).then(() => window.location = '/login')
            // Redirect or show a success message
        } catch (error) {
            this.setState({ loading: false, errorMessage: 'Failed to reset password' });
            Swal.fire({
                title: 'ดำเนินการไม่สำเร็จมีบางอย่างผิดพลาด',
                // message: 'ดำเนินการสำเร็จ กรุณาตรวจสอบอีเมลของท่าน',
                type: 'error',
                customClass: {
                    container: 'my-swal',
                },
            })
        } finally {
            this.setState({ newPassword: '', confirmPassword: '' });

        }
    };

    render() {
        const { classes } = this.props;
        const { newPassword, confirmPassword, errorMessage, loading } = this.state;

        return (
            <Grid container className={classes.container}>
                <div className={classes.logotypeContainer}>
                    <img src={presenselogo} alt='logo' className={classes.logotypeImage} />
                </div>
                <div className={classes.formContainer}>
                    <div className={classes.form}>
                        <img src={presenseAlternatelogo} alt='logoAlternate' className={classes.logotypeImageAlternate} />
                        <Typography variant='h4'>
                            ตั้งค่ารหัสผ่านใหม่
                        </Typography>
                        <form className={classes.form} onSubmit={this.handleSubmit}>
                            <TextField
                                autoFocus={true}
                                id="newPassword"
                                label="รหัสผ่านใหม่"
                                type="password"
                                className={classes.textField}
                                value={newPassword}
                                onChange={this.handleChange('newPassword')}
                                margin="normal"
                                fullWidth
                                variant='outlined'
                                required
                            />
                            <TextField
                                id="confirmPassword"
                                label="ยืนยันรหัสผ่านใหม่"
                                type="password"
                                className={classes.textField}
                                value={confirmPassword}
                                onChange={this.handleChange('confirmPassword')}
                                margin="normal"
                                fullWidth
                                variant='outlined'
                                required
                            />
                            {errorMessage && (
                                <Typography color="error" variant="body2">
                                    {errorMessage}
                                </Typography>
                            )}
                            <div className={classes.formButtons}>
                                <Button
                                    style={{ marginTop: '1vh' }}
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    disabled={loading}
                                >
                                    เปลี่ยนรหัสผ่าน
                                </Button>
                                {loading && <CircularProgress size={24} className={classes.buttonProgress} />}
                            </div>
                        </form>
                    </div>
                    <Typography color='primary' className={classes.copyright}>
                        © Copyright 2024 Emetworks.
                    </Typography>
                </div>
            </Grid>
        );
    }
}

ResetPasswordPage.propTypes = {
    classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
    container: {
        height: '100vh',
        width: '100vw',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        top: 0,
        left: 0,
    },
    logotypeContainer: {
        backgroundColor: theme.palette.primary.main,
        width: '60%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            width: '50%',
        },
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    logotypeImageAlternate: {
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },
    logotypeImage: {
        width: 400,
        marginBottom: theme.spacing.unit * 4,
    },
    logotypeText: {
        color: 'white',
        fontWeight: 500,
        fontSize: 84,
        [theme.breakpoints.down('md')]: {
            fontSize: 48,
        },
    },
    formContainer: {
        width: '40%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            width: '50%',
        },
    },
    form: {
        width: 320,
    },
    formButtons: {
        width: '100%',
        marginTop: theme.spacing.unit * 4,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        left: '50%',
        marginLeft: -12,
    },
    copyright: {
        position: 'absolute',
        bottom: theme.spacing.unit * 2,
    },
    version: {
        color: '#FFFFFF',
        marginTop: 50,
    },
    button: {
        width: '100%',
    },
    textField: {
        // margin: theme.spacing.unit,
        // width: '80%',
    },
});

export default withStyles(styles, { withTheme: true })(withRouter(ResetPasswordPage));
